module.exports = __webpack_public_path__ + "media/recipes/140-933ac6b1.png";